import styled from "styled-components";
import cssVars from "../../styles/cssVariables.vars";

export const StyledQrPendingNotice = styled.aside`
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 11;

    box-sizing: border-box;
    width: min(22rem, calc(100vw - 2rem));
    padding: 0.875rem 1rem;
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;

    background-color: ${cssVars.colorGrey[7]};
    border-left: 4px solid rgb(230, 155, 30);
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);

    >svg {
        flex-shrink: 0;
        margin-top: 0.125rem;
        font-size: 1.25rem;
        color: rgb(230, 155, 30);
    }

    >div {
        flex: 1;
        min-width: 0;

        >h2 {
            font-size: 0.875rem;
            font-weight: 600;
            color: ${cssVars.colorGrey[1]};
        }

        >p {
            margin-top: 0.25rem;
            font-size: 0.8125rem;
            line-height: 1.4;
            color: ${cssVars.colorGrey[3]};
            overflow-wrap: anywhere;
        }

        >button {
            margin-top: 0.625rem;
            padding: 0.375rem 0.75rem;
            border-radius: 0.25rem;
            border: none;
            background-color: rgb(230, 155, 30);
            color: white;
            font-size: 0.8125rem;
            font-weight: 600;
            cursor: pointer;

            &:hover {
                filter: brightness(1.1);
            }
        }
    }

    >.close {
        flex-shrink: 0;
        display: flex;
        padding: 0.25rem;
        border: none;
        border-radius: 0.25rem;
        background-color: transparent;
        color: ${cssVars.colorGrey[4]};
        cursor: pointer;

        &:hover {
            background-color: ${cssVars.colorGrey["6h"]};
            color: ${cssVars.colorGrey[1]};
        }
    }
`;
